"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Avatar: ()=>_avatar.Avatar,
    avatarClassNames: ()=>_avatar.avatarClassNames,
    renderAvatar_unstable: ()=>_avatar.renderAvatar_unstable,
    useAvatarStyles_unstable: ()=>_avatar.useAvatarStyles_unstable,
    useAvatar_unstable: ()=>_avatar.useAvatar_unstable,
    getInitials: ()=>_index.getInitials,
    partitionAvatarGroupItems: ()=>_index.partitionAvatarGroupItems,
    AvatarGroup: ()=>_avatarGroup.AvatarGroup,
    avatarGroupClassNames: ()=>_avatarGroup.avatarGroupClassNames,
    renderAvatarGroup_unstable: ()=>_avatarGroup.renderAvatarGroup_unstable,
    useAvatarGroupContextValues: ()=>_avatarGroup.useAvatarGroupContextValues,
    useAvatarGroupStyles_unstable: ()=>_avatarGroup.useAvatarGroupStyles_unstable,
    useAvatarGroup_unstable: ()=>_avatarGroup.useAvatarGroup_unstable,
    AvatarGroupItem: ()=>_avatarGroupItem.AvatarGroupItem,
    avatarGroupItemClassNames: ()=>_avatarGroupItem.avatarGroupItemClassNames,
    renderAvatarGroupItem_unstable: ()=>_avatarGroupItem.renderAvatarGroupItem_unstable,
    useAvatarGroupItemStyles_unstable: ()=>_avatarGroupItem.useAvatarGroupItemStyles_unstable,
    useAvatarGroupItem_unstable: ()=>_avatarGroupItem.useAvatarGroupItem_unstable,
    AvatarGroupPopover: ()=>_avatarGroupPopover.AvatarGroupPopover,
    avatarGroupPopoverClassNames: ()=>_avatarGroupPopover.avatarGroupPopoverClassNames,
    renderAvatarGroupPopover_unstable: ()=>_avatarGroupPopover.renderAvatarGroupPopover_unstable,
    useAvatarGroupPopoverStyles_unstable: ()=>_avatarGroupPopover.useAvatarGroupPopoverStyles_unstable,
    useAvatarGroupPopover_unstable: ()=>_avatarGroupPopover.useAvatarGroupPopover_unstable,
    AvatarContextProvider: ()=>_index1.AvatarContextProvider,
    AvatarGroupProvider: ()=>_index1.AvatarGroupProvider,
    useAvatarContext: ()=>_index1.useAvatarContext,
    useAvatarGroupContext_unstable: ()=>_index1.useAvatarGroupContext_unstable
});
const _avatar = require("./Avatar");
const _index = require("./utils/index");
const _avatarGroup = require("./AvatarGroup");
const _avatarGroupItem = require("./AvatarGroupItem");
const _avatarGroupPopover = require("./AvatarGroupPopover");
const _index1 = require("./contexts/index");
 //# sourceMappingURL=index.js.map

//# sourceMappingURL=index.js.map